export default {
  modal: { active: false },

  services           : [],
  servicesAppearance : 'grid', // list, grid
  servicesBreak      : 5,
  servicesDuration   : 10,
  servicesLoading    : false,
}
